<template>
    <div ref="wrap" class="integral-wrap">
        <div class="head" :style="{'background-color': topnav_bg}">
            <img class="left-arraw" @click="goBack" src="../../assets/lifecircle/left-arraw-black.png" alt="">
            <div class="active-title">{{active_detail.topic_title}}</div>
        </div>
        <div class="head-bg"><div class="time-text">{{active_detail.time}}</div></div>
        <div class="main">
            <div class="box">
                <img class="img" src="../../assets/lifecircle/topic-active-detail.png" alt="">
                <div class="text">{{active_detail.desc}}</div>
            </div>
            <div class="box">
                <img class="img" src="../../assets/lifecircle/topic-active-rule.png" alt="">
                <div class="text" v-html="active_detail.rule_desc"></div>
            </div>
            <div class="box">
                <img class="img" src="../../assets/lifecircle/topic-active-wdcy.png" alt="">
                <div class="topic-info">
                    <div>在指定话题下发帖</div>
                    <span v-if="active_detail.type == 1">{{active_detail.sign_count}}/{{active_detail.day_count}}</span>
                </div>
                <div class="topic-name" @click="goTopic">{{active_detail.topic_title}}</div>
                <div class="topic-sign" v-if="active_detail.type == 1 && active_detail.day_count > 1">
                    <div class="topic-sign-item" v-for="(item, index) in days" :key="index">
                        <div class="topic-sign-picwrap">
                            <img v-if="item.is_sign===0" class="topic-sign-pic" src="../../assets/lifecircle/topic-sign-wait.png" alt="">
                            <img v-else class="topic-sign-pic" src="../../assets/lifecircle/topic-sign-done.png" alt="">
                            <div class="topic-sign-date" v-if="item.is_sign===0">{{formatTime(item.date, 'd')}}</div>
                        </div>
                        <div class="topic-sign-day">{{formatTime(item.date, 'm/d')}}</div>
                    </div>
                </div>
                <div class="topic-btn">
                    <van-button
                    :disabled="active_detail.type == 1 && active_detail.sign_count === active_detail.day_count"
                    @click="goPublic"
                    >去发帖</van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from 'vant';
export default {
    data() {
        return {
            persent: 0,
            topic_tatus: 1,
            active_detail: {},
            days: [], //打卡天数
        }
    },
    computed: {
        topnav_bg(){
            return `rgba(255,255,255,${this.persent})`
        }
    },
    methods: {
        goBack(){
            GoBack.postMessage('');
        },
        goTopic(){
            Finish.postMessage('');
        },
        goPublic(){
            const data = {
                topic_title: this.active_detail.topic_title, 
                topic_id: this.active_detail.topic_id,
                activity_id: this.active_detail.activity_id,
                topic_desc: this.active_detail.desc,
                guide_words: this.active_detail.guide_words
            }
            GoToReleasePage.postMessage(JSON.stringify(data));
        },
        formatTime(date, type){
            switch (type) {
                case '年月日':
                    const reg = /(\d{4})\-(\d{2})\-(\d{2})/;
                    return String(date).split(" ")[0].replace(reg, "$1年$2月$3日")
                case 'm/d':
                    const date_arr = String(date).split("-");
                    return `${Number(date_arr[1])}/${Number(date_arr[2])}`
                case 'd':
                    {
                        const date_arr = String(date).split("-");
                        return `${Number(date_arr[2])}`
                    }
                default:
                    return ''
            }
        },
        pageScroll(){
            const scroll = document.body.scrollTop || document.documentElement.scrollTop;
            if (scroll <= 50 && scroll >= 0) {
                this.persent = scroll/50
            }else if (scroll > 50 && this.persent !== 1){
                this.persent = 1
            }
        },
        getDetail(){
            this.$api.post("/life-moments/member/topic/activity?topic_id=" + this.$route.query.topic_id).then((res) => {
                this.active_detail = {
                    activity_id: res.activity._id,
                    title: res.activity.title,
                    desc: res.activity.desc,
                    rule_desc: res.activity.rule_desc,
                    topic_title: res.topic.title,
                    topic_id: res.topic._id,
                    status: res.activity.status,
                    sign_count: res.sign_count,
                    day_count: res.day_count,
                    type: res.activity.type,
                    guide_words: res.topic.guide_words,
                    time: this.formatTime(res.activity.start_time, '年月日') + '-' + this.formatTime(res.activity.end_time, '年月日'), 
                };
                this.days = res.days;
            }).catch((err) => {
                if (err.response && err.response.data) {
                    Toast(err.response.data.message);
                }else if (err.message) {
                    Toast(err.message);
                }
            })
        }
    },
    created() {
        this.getDetail();
    },
    mounted() {
        window.addEventListener('scroll', this.pageScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.pageScroll)
    },
}
</script>

<style lang="less" scoped>
.integral-wrap {
    box-sizing: border-box;
    min-height: 100vh;
    padding-bottom: 70px;
    background-color: #8388E2;
    div{
        box-sizing: border-box;
    }
    img{
        display: block;
    }
    .head{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100px;
        padding-top: 54px;
        padding-left: 15px;
        background-color: rgba(255,255,255,0);
        z-index: 999;
        .left-arraw{
            width: 24px;
            height: 24px;
        }
        .active-title{
            position: absolute;
            top: 54px;
            left: 0;
            padding-left: 45px;
            padding-right: 30px;
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            text-align: center;
            white-space: nowrap;
        }
    }
    .head-bg{
        position: relative;
        height: 280px;
        background-image: url('../../assets/lifecircle/topic-bg.png');
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .time-text{
            position: absolute;
            top: 158px;
            left: 50%;
            transform: translateX(-50%);
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 20px;
            text-align: center;
            white-space: nowrap;
        }
    }
    .main{
        padding: 0 15px;
        .box{
            position: relative;
            margin-top: 44px;
            padding: 55px 15px 35px 15px;
            background-color: #FFFFFF;
            border-radius: 12px;
            .img{
                position: absolute;
                top: -20px;
                left: 50%;
                transform: translate(-50%);
                width: 131px;
            }
            .text{
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.8);
                line-height: 22px;
            }
            .topic-info{
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0 12px;
                border-radius: 8px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: rgba(0, 0, 0, 0.8);
                line-height: 26px;
            }
            .topic-name{
                padding: 0 12px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #6554E0;
                line-height: 22px;
            }
            .topic-sign{
                display: flex;
                flex-wrap: wrap;
                .topic-sign-item{
                    flex-basis: 12.06%;
                    margin-top: 18px;
                    margin-right: 2.539%;
                }
                .topic-sign-item:nth-of-type(7n){
                    margin-right: 0;
                }
                .topic-sign-picwrap{
                    position: relative;
                }
                .topic-sign-date{
                    position: absolute;
                    bottom: 2px;
                    left: 50%;
                    transform: translateX(-50%);
                    font-size: 18px;
                    font-family: PingFangSC-Semibold, PingFang SC;
                    font-weight: 600;
                    color: #D0D0FF;
                    line-height: 25px;
                }
                .topic-sign-pic{
                    width: 100%;
                }
                .topic-sign-day{
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: rgba(0, 0, 0, 0.4);
                    line-height: 18px;
                    text-align: center;
                }
            }
            .topic-btn{
                display: flex;
                justify-content: center;
                .van-button {
                    margin-top: 30px;
                    width: 84px;
                    height: 44px;
                    padding: 0;
                    border-radius: 22px;
                    font-size: 16px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    background: linear-gradient(90deg, #FF7641 0%, #FF0B40 100%)
                }
                .van-button--disabled{
                    opacity: 1;
                    background: rgba(222, 99, 0, .2)!important;
                }
            }
        }
    }
}
.isiOSX {
    .van-nav-bar {
        padding-top: 43px;
    }

    .help-content {
        padding-top: 90px;
    }
}
</style>